import LocalDataGrid from "@/components/DataGrid/LocalDataGrid";
import messagesColumns from "./columns";
import { useMemo } from "react";
import { GetTripMessagesResObj, TripMessageObj } from "@/types/interfaces/crm";
import { UseQueryResult } from "@tanstack/react-query";
import Loader from "@/components/Loader/Loader";
import ErrorFallback from "@/components/ErrorFallback/ErrorFallback";

interface Props {
  queryClient: UseQueryResult<GetTripMessagesResObj>
}
const Messages = ({ queryClient }: Props) => {
  const columns = useMemo(() => messagesColumns, []);
  const messages: TripMessageObj[] = queryClient.data?.messages || [];

  if (queryClient.isLoading) {
    return <Loader />;
  }

  if (queryClient.isError) {
    return <ErrorFallback retry={queryClient.refetch} />;
  }

  return (
    <LocalDataGrid
      idProperty="messageId"
      columnDefs={columns}
      rowData={messages}
      hideCsvExport
      hidePagination
      rowHeight={55}
      sortable
      emptyText="No data found"
    />
  );
};

export default Messages;
